declare const jQuery

export const smoothScrollLinks = (): void => {
  Array.from(document.querySelectorAll('a')).forEach((link: HTMLElement) => {
    if (link.getAttribute('href')?.includes('#')) {
      const idLink = `${link.getAttribute('href')?.split('#')[1]}`

      const target = document.getElementById(idLink)

      if (target) {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const offset = jQuery(target).offset().top

          jQuery('html, body').animate({
            scrollTop: offset
          }, 500)
        })
      }
    }
  })
}
